module.exports = "<app-listings></app-listings>\r\n"